import React from 'react'
import classnames from 'classnames'
import moment from 'moment'
import { differenceBy } from 'lodash'
import { DatePicker, message } from 'antd'
import styles from './dateChoose.module.less'
import { Icon } from '@ant-design/compatible'

// import './dateChoose.less'
export default class DateChoose extends React.Component {
    state = {
        listSwi: false,
        selectedText: '',
        startValue: null,
        endValue: null,
        endOpen: false,
        startOpen: false,
        isProfitCenter: false,
        timeBtnList:[
            { name: '今天', value: 'today', selected: false },
            { name: '昨天', value: 'yesterday', selected: false },
            { name: '最近7天', value: 'seven_days', selected: false },
            { name: '最近30天', value: 'thirty_days', selected: false },
            { name: '最近90天', value: 'ninetyDays', selected: false },
            { name: '最近一年', value: 'one_year_days', selected: false },
            { name: '本周', value: 'week', selected: false },
            { name: '本月', value: 'month', selected: false },
            { name: '上月', value: 'last_month', selected: false },
            { name: '本年', value: 'year', selected: false }
        ],
        endNotBeToday: false, //快捷时间结束时间到昨天
    }

    /* readme
    * 接收参数
    *   defaultValue (传时间戳或者字符串) 字符串可用值--today,yesterday,seven_days,thirty_days,one_year_days,week,month,last_month,year，时间戳13位数组
    *
    *   timerChange--父组件回调函数
    * */
    componentDidMount() {
        let { defaultValue, isClick, isninetyDay, endNotBeToday } = this.props
        let { timeBtnList, startValue, endValue, selectedText } = this.state
        if (isninetyDay) {
            timeBtnList = [
                { name: '今天', value: 'today', selected: false },
                { name: '昨天', value: 'yesterday', selected: false },
                { name: '最近7天', value: 'seven_days', selected: false },
                { name: '最近30天', value: 'thirty_days', selected: false },
                { name: '最近90天', value: 'ninetyDays', selected: false },
                { name: '最近一年', value: 'one_year_days', selected: false },
                { name: '本周', value: 'week', selected: false },
                { name: '本月', value: 'month', selected: false },
                { name: '上月', value: 'last_month', selected: false },
                { name: '本年', value: 'year', selected: false }
            ]
        }
        if (isClick === false) {
            if (typeof defaultValue === 'undefined') {
                selectedText = '请选择'
            } else {
                if (typeof defaultValue === 'string') {
                    for (let i in timeBtnList) {
                        if (timeBtnList[i].value === defaultValue) {
                            timeBtnList[i].selected = true
                            break
                        }
                    }
                    let dateArr = this.switchDate(defaultValue)
                    this.switchItem(defaultValue)
                    startValue = dateArr[0]
                    endValue = dateArr[1]
                } else if (Array.isArray(defaultValue) && defaultValue.length === 2) {
                    if (defaultValue[0] && defaultValue[1]) {
                        startValue = moment(defaultValue[0])
                        endValue = moment(defaultValue[1])
                        selectedText = '快捷'
                    } else {
                        selectedText = '快捷'
                    }
                    this.setState({
                        selectedText
                    })
                } else {
                    selectedText = '请选择'
                    this.setState({
                        selectedText
                    })
                }
            }
            if (endNotBeToday) {
                timeBtnList = differenceBy(timeBtnList, [{ value: 'today' }], 'value')
            }
            this.setState({
                startValue,
                endValue,
                timeBtnList,
                isProfitCenter: this.props.isProfitCenter,
                endNotBeToday: endNotBeToday || false
            })
        }
    }

    componentWillReceiveProps(nextprops) {
        let { defaultValue, isClick } = nextprops
        let { timeBtnList, startValue, endValue, selectedText } = this.state
        if (isClick === true) {
            if (typeof defaultValue === 'undefined') {
                selectedText = '请选择'
            } else {
                if (typeof defaultValue === 'string') {
                    for (let i in timeBtnList) {
                        if (timeBtnList[i].value === defaultValue) {
                            timeBtnList[i].selected = true
                            break
                        }
                    }
                    let dateArr = this.switchDate(defaultValue)
                    this.switchItem(defaultValue)
                    startValue = dateArr[0]
                    endValue = dateArr[1]
                } else if (Array.isArray(defaultValue) && defaultValue.length === 2) {
                    if (defaultValue[0] && defaultValue[1]) {
                        startValue = moment(defaultValue[0])
                        endValue = moment(defaultValue[1])
                        selectedText = '快捷'
                    } else {
                        selectedText = '快捷'
                    }
                    this.setState({
                        selectedText
                    })
                } else {
                    selectedText = '请选择'
                    this.setState({
                        selectedText
                    })
                }
            }
            this.setState({
                startValue,
                endValue,
                timeBtnList,
                isProfitCenter: nextprops.isProfitCenter
            })
        }
    }

    disabledStartDate = startValue => {
        const endValue = this.state.endValue
        if (!startValue || !endValue) {
            return false
        }
        return startValue.valueOf() > endValue.valueOf()
    }
    disabledEndDate = endValue => {
        const startValue = this.state.startValue
        if (!endValue || !startValue) {
            return false
        }
        return endValue.valueOf() < startValue.valueOf()
    }
    handleStartOpenChange = open => {
        if (!open && !this.state.endValue) {
            this.setState({ endOpen: true })
        }
        this.setState({ startOpen: true })
    }
    handleEndOpenChange = open => {
        this.setState({ endOpen: open })
    }
    // 选择对应时间
    selectLimitDate = (sort, index) => {
        let { startValue, endValue, timeBtnList } = this.state
        timeBtnList.map((item) => {
            item.selected = false
        })
        timeBtnList[index].selected = true
        let dateArr = this.switchDate(sort, 1)
        this.switchItem(sort)
        startValue = dateArr[0]
        endValue = dateArr[1]
        this.setState({
            startValue, endValue, timeBtnList
        })
    }
    // 根据状态选择日期
    switchDate = (sort, reload) => {
        let { endNotBeToday } = this.props
        let dateArr = []
        let nowDay = moment().endOf('day')
        var yesterdayEnd = moment().subtract(1, 'days').endOf('day')
        switch (sort) {
            case 'yesterday':
                dateArr[0] = moment().subtract(1, 'days').startOf('day')
                dateArr[1] = this.getEndMoment(yesterdayEnd)
                break
            case 'today':
                dateArr[0] = moment().startOf('day')
                dateArr[1] = this.getEndMoment(nowDay)
                break
            case 'month':
                dateArr[0] = moment().startOf('month')
                dateArr[1] = this.getEndMoment(nowDay)
                break
            case 'seven_days':
                dateArr[0] = moment().startOf('day').subtract(endNotBeToday?7:6, 'days')
                dateArr[1] = this.getEndMoment(nowDay)
                break
            case 'ninetyDays':
                dateArr[0] = moment().startOf('day').subtract(endNotBeToday?90:89, 'days')
                dateArr[1] = this.getEndMoment(nowDay)
                break
            case 'add_three_days':
                dateArr[0] = this.getEndMoment(nowDay)
                dateArr[1] = moment().startOf('day').add(3, 'days')
                break
            case 'add_seven_days':
                dateArr[0] = this.getEndMoment(nowDay)
                dateArr[1] = moment().startOf('day').add(7, 'days')
                break
            case 'thirty_days':
                dateArr[0] = moment().startOf('day').subtract(endNotBeToday?30:29, 'days')
                dateArr[1] = this.getEndMoment(nowDay)
                break
            case 'ninety_days':
                dateArr[0] = moment().startOf('day').subtract(3, 'months')
                dateArr[1] = this.getEndMoment(nowDay)
                break
            case 'one_year_days':
                dateArr[0] = moment().startOf('day').subtract(endNotBeToday?365:364, 'days')
                dateArr[1] = this.getEndMoment(nowDay)
                break
            case 'week':
                dateArr[0] = moment().startOf('day').startOf('week')
                dateArr[1] = this.getEndMoment(nowDay)
                break
            case 'last_month':
                dateArr[0] = moment().month(moment().month() - 1).startOf('month')
                dateArr[1] = moment().month(moment().month() - 1).endOf('month')
                break
            case 'year':
                dateArr[0] = moment().startOf('year')
                dateArr[1] = this.getEndMoment(nowDay)
                break
            default:
                dateArr[0] = moment().startOf('day')
                dateArr[1] = this.getEndMoment(nowDay)
        }
        this.timeChange(dateArr, reload)
        return dateArr
    }

    getEndMoment = (end) => {
        let { endNotBeToday } = this.props
        var end_date = (endNotBeToday ? moment().subtract(1, 'days').endOf('day') : null) || end
        return end_date
    }

    // 选择对应的文字
    switchItem = (sort) => {
        let { selectedText } = this.state
        // let that = this
        switch (sort) {
            case '':
                selectedText = '快捷'
                break
            case 'yesterday':
                selectedText = '昨天'
                break
            case 'today':
                selectedText = '今天'
                break
            case 'month':
                selectedText = '本月'
                break
            case 'ninetyDays':
                selectedText = '最近90天'
                break
            case 'seven_days':
                selectedText = '最近7天'
                break
            case 'thirty_days':
                selectedText = '最近30天'
                break
            case 'one_year_days':
                selectedText = '最近一年'
                break
            case 'week':
                selectedText = '本周'
                break
            case 'last_month':
                selectedText = '上月'
                break
            case 'year':
                selectedText = '本年'
                break
            case 'add_three_days':
                selectedText = '未来三天'
                break
            case 'add_seven_days':
                selectedText = '未来一周'
                break
            default:
                selectedText = '快捷'
                break
        }
        this.setState({
            selectedText
        })
    }

    timeChange = (datastring, reload) => {
        this.setState({
            listSwi: false
        }, () => {
            if (this.props.timerChange) {
                this.props.timerChange(datastring, reload, false)
            }
        })
    }

    changeFn = (date, dateString, type) => {
        let { startValue, endValue, selectedText, timeBtnList } = this.state
        if (!date) {
            startValue = null
            endValue = null
            selectedText = '快捷'
        } else {
            if (type === 'start') {
                startValue = date
                this.setState({
                    startOpen: false
                })
            } else {
                endValue = date
                this.setState({
                    endOpen: false
                })
            }
            selectedText = '快捷'
        }
        timeBtnList.map((item) => {
            item.selected = false
        })
        this.setState({
            selectedText,
            timeBtnList,
            startValue,
            endValue
        }, () => {
            if ((endValue && startValue) || (!endValue && !startValue)) {
                let _arr = []
                if (date) {
                    _arr = [startValue, endValue]
                }
                this.timeChange(_arr)
            }
        })
    }

    clearFn = () => {
        this.setState({
            startValue: null,
            endValue: null,
            endOpen: false,
            startOpen: false
        })
    }
    render() {
        const { startValue, endValue, listSwi, timeBtnList, selectedText } = this.state
        const { ifConvenient, ifshowClear } = this.props
        const _selectItem = timeBtnList.find(ele => ele.selected === true)
        return (
            <div style={{ 'display': 'inline-block' }}>
                <span>
                    <DatePicker
                        style={{ width: this.props.isStatus ? '140px' : '196px', minWidth: this.props.isStatus ? '140px !important' : '196px' }}
                        allowClear={this.props.hasOwnProperty('ifshowClear') ? ifshowClear : true}
                        disabledDate={this.disabledStartDate}
                        format={this.props.isStatus ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss'}
                        showTime={!this.props.time}
                        showToday={true}
                        value={startValue}
                        dropdownClassName={classnames([styles.dropdownstyle])}
                        onChange={(e1, e2) => this.changeFn(e1, e2, 'start')}
                        onOpenChange={this.handleStartOpenChange}
                        renderExtraFooter={() => null}
                    />
                    <span className={styles.to_} style={{ margin: this.props.orderStatus ? '0px 4px' : '0px 8px' }} >至</span>
                    <DatePicker
                        style={{ width: this.props.isStatus ? '140px' : '196px', minWidth: this.props.isStatus ? '140px !important' : '196px' }}
                        allowClear={this.props.hasOwnProperty('ifshowClear') ? ifshowClear : true}
                        disabledDate={this.disabledEndDate}
                        format={this.props.isStatus ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss'}
                        showToday={true}
                        showTime={!this.props.time}
                        value={endValue}
                        dropdownClassName={classnames([styles.dropdownstyle])}
                        onChange={(e1, e2) => this.changeFn(e1, e2, 'end')}
                        onOpenChange={this.handleEndOpenChange}
                        renderExtraFooter={() => null}
                    />
                </span>
                {ifConvenient
                    ? !this.props.orderStatus ? <div className={classnames(
                        {
                            [styles.pointer]: true,
                            [styles.DateChoose]: true
                        })} style={{ margin: '0px 8px', padding: '0px 8px' }}>
                        <span className=''>
                            {selectedText}&nbsp;&nbsp;
                            <Icon className={styles.icons} type="down" />
                        </span>
                        <div className={styles.DateChoose__list}>
                            <ul >{
                                timeBtnList.map((item, index) => {
                                    return (
                                        <li className={styles.DateChoose__item} key={index}>
                                            <a key={index} className={classnames(
                                                {
                                                    [styles.time_btn]: true,
                                                    [styles.active]: !!item.selected
                                                }
                                            )} onClick={this.selectLimitDate.bind(this, item.value, index)} data-sort='today'>{item.name}</a>

                                        </li>
                                    )
                                })}
                            </ul>
                        </div>

                    </div>

                        : <div className={classnames(
                            {
                                [styles.pointer]: true,
                                [styles.DateChoose]: true
                            })} style={{ margin: '0px 8px', padding: '0px 8px', position: 'absolute', left: '130px', top: '0px' }}>
                            <span className=''>
                                {selectedText}&nbsp;&nbsp;
                                <Icon className={styles.icons} type="down" />
                            </span>
                            <div className={styles.DateChoose__list} style={{ width: '204px' }}>
                                <ul >{
                                    timeBtnList.map((item, index) => {
                                        // console.log(item.selected + index)
                                        return (
                                            <li className={styles.DateChoose__item} key={index}>
                                                <a key={index} className={classnames(
                                                    {
                                                        [styles.time_btn]: true,
                                                        [styles.active]: !!item.selected
                                                    }
                                                )} onClick={this.selectLimitDate.bind(this, item.value, index)} data-sort='today'>{item.name}</a>

                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>

                        </div>
                    : null}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/compenents/newDateChoose.js